import React from "react";
import styles from "./places.pop-up.module.scss";
import { PlaceSearchItem } from "../../types/cities";

type PlacesPopUpProps = {
  places: PlaceSearchItem[];
  onSelect: (place: PlaceSearchItem) => void;
};

const PlacesPopUp = ({ places, onSelect }: PlacesPopUpProps) => {
  if (!places.length) return null;

  return (
    <div className={styles.container}>
      {places.map((place) => (
        <div 
          key={place.place_id}
          className={styles.item}
          onClick={() => onSelect(place)}
        >
          <div
            className={styles["icon-wrap"]}
            style={{ backgroundColor: place.iconBg ?? "#e2e8f0" }}
          >
            <img src={place.icon} alt="" className={styles.icon} />
          </div>

          <div className={styles.text}>
            <span className={styles.name}>{place.name}</span>
            <span className={styles.address}>{place.formatted_address}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlacesPopUp;
